import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'relative',
      '& $downloadCsvBtn': {
        position: 'absolute',
      },
    },
    buttonsWrapper: {
      display: 'flex',
      position: 'absolute',
      right: 0,
      top: 15,
      [theme.breakpoints.up('md')]: {
        top: '-38px',
      },
      '& button': {
        marginRight: SMALL_MARGIN,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
    downloadCsvBtn: {},
    tableWrap: {
      overflowX: 'auto',
      paddingLeft: 1,
    },
    tableInnerWrap: {
      marginTop: MIDDLE_MARGIN,
      marginBottom: 1,
      borderRight: '1px solid transparent',
    },
    tableInnerWrapWithoutMargin: {
      marginTop: 0,
    },
    tableBody: {
      borderRadius: 5,
      boxShadow: '0px 0px 0px 1px #484572',
    },
    tableHead: {
      borderRadius: '5px 5px 0 0',
      backgroundColor: '#1B1925',
      '& $tableHeadCell': {
        '&:first-child': {
          paddingLeft: SMALL_MARGIN,
        },
        '&:last-child': {
          paddingRight: SMALL_MARGIN,
        },
      },
    },
    tableHeadCell: {
      color: '#C9C4D4',
      paddingLeft: 8,
      paddingRight: 8,
      borderBottom: 0,

      '&:first-child': {
        borderRadius: '5px 0 0 0',
      },
      '&:last-child': {
        borderRadius: '0 5px 0 0',
      },
    },
    tableHeadSortable: {
      cursor: 'pointer',
    },
    boxHeading: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      lineHeight: 1.2,
    },
    tableBodyCell: {
      '&:first-child $contentCell:first-child': {
        borderTopLeftRadius: 5,
      },
      '&:first-child $contentCell:last-child': {
        borderTopRightRadius: 5,
      },
      '&:last-child $contentCell:first-child': {
        borderBottomLeftRadius: 5,
      },
      '&:last-child $contentCell:last-child': {
        borderBottomRightRadius: 5,
      },
    },
    analyticsRow: {
      backgroundColor: '#2D293B',
      '&:nth-child(2n)': {
        backgroundColor: '#23202E',
      },
      '&:last-child': {
        borderRadius: '0 0 5px 0',
      },
      '& $contentCell': {
        '&:first-child': {
          paddingLeft: SMALL_MARGIN,
        },
        '&:last-child': {
          paddingRight: SMALL_MARGIN,
        },
      },
    },
    clickableRow: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
    contentCell: {
      color: '#ffffff',
      borderWidth: 0,
      paddingLeft: 8,
      paddingRight: 8,
    },
    arrayCell: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    loadingCell: {
      position: 'relative',
      width: 24,
      margin: '0 auto',
      '& $cellLoaderContainer': {
        width: 24,
        height: 24,
      },
    },
    cellLoaderContainer: {
      border: '2px solid transparent',
      borderTop: `2px solid ${colorsPalette.white}`,
      borderLeft: `2px solid ${colorsPalette.white}`,
      borderBottom: `2px solid ${colorsPalette.white}`,
      borderRadius: '100%',
      animationName: 'fu-rotate',
      animationDuration: '1.5s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
    },
    imageCellContent: {
      width: 50,
      height: 30,
      objectFit: 'cover',
    },
    imageCellWithText: {
      marginRight: 10,
    },
    imageCellWithTextWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    sorted: {
      color: theme.palette.primary.main,
    },
    sortedDesc: {
      transform: 'rotate(180deg)',
    },
    paginationWrap: {
      marginTop: 20,
    },
    tableLink: {
      color: colorsPalette.white,

      '&:hover': {
        color: colorsPalette.blue,
      },
    },
    emptyStateWrap: {
      height: 300,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#ffffff50',
    },
    emptyStateTitle: {
      [theme.breakpoints.up('md')]: {
        fontSize: 48,
      },
    },
    emptyStateSubTitle: {
      textAlign: 'center',
    },
    iconCell: {
      padding: 6,
      width: 50,
    },
    icon: {
      width: 14,
      height: 14,
      cursor: 'pointer',
    },
    statusText: {
      marginTop: 5,
      [theme.breakpoints.up('sm')]: {
        marginBottom: 4,
        marginTop: 0,
      },
    },
    completed: {
      color: colorsPalette.green,
    },
    notStarted: {
      color: colorsPalette.gray,
    },
    progressCellWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    progressWrapper: {
      flex: 1,
      position: 'relative',
      height: 6,
      marginRight: SMALL_MARGIN / 2,
      marginTop: 3,
    },
    progressLineWrapper: {
      borderRadius: 5,
      height: 6,
      background: fade(colorsPalette.blue, 0.33),
      opacity: 1,
    },
    progressLine: {
      borderRadius: 5,
      height: 6,
      background: colorsPalette.blue,
    },
    progressValueWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('sm')]: {
        width: 35,
      },
    },
    completedProgress: {
      color: colorsPalette.green,
    },
    contentLoaderCell: {
      position: 'relative',
      height: 150,
    },
    viewDetailsIcon: {
      width: 20,
      height: 20,
      paddingTop: 4,
    },
    othersText: {
      fontSize: 10,
      lineHeight: '18px',
      color: colorsPalette.violetSecondary,
    },
    othersIcon: {
      width: 10,
      height: 10,
      marginLeft: 4,
      color: fade(colorsPalette.white, 0.33),
      cursor: 'pointer',
    },
    tooltip: {
      maxWidth: 250,
      textAlign: 'left',
      '&:before': {
        display: 'none',
      },
    },
    meta: {
      color: colorsPalette.violetSecondary,
      fontSize: 10,
      lineHeight: '18px',
      wordWrap: 'break-word',
      wordBreak: 'break-word',
    },
    loaderWrapper: {
      width: '100%',
      height: 300,
      position: 'relative',
    },
  }),
);

export default useStyles;
